import AdditionalFieldTitleWithLangSelect from "./additionalFieldTitleWithLangSelect.container";

export default AdditionalFieldTitleWithLangSelect;